import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { applyLinkToSelection } from 'common/Prose/utils/link'
import { computed } from 'mobx'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export const useLinkSelection = () => {
  const editorView = useEditorView()

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const turnSelectionIntoLink = (link: string | undefined, text: string): void =>
    applyLinkToSelection(editorView, { link, text })

  const hasLink = computed(() => almanacState.activeMarks.has(editorView.state.schema.marks.link)).get()

  const hasCodeBlock = computed(() => almanacState.activeNodes.has(editorView.state.schema.nodes.code_block)).get()

  return { active: hasLink, turnSelectionIntoLink, disabled: hasCodeBlock }
}
